const OVERLAY_EVENTS_SELECTORS_ID = {
    OVERLAY_CGP_ID: '#cgp_overlay'
};

export { OVERLAY_EVENTS_SELECTORS_ID };
